import { useTheme, Box } from '@mui/material';
import { ContentCard } from '../../components/ContentCard/ContentCard';
import { Copy } from '../../copy/Copy';
import { dynamicTextColor } from '../../helpers/dynamicTextColor';
import { Button } from '../../components/Button/Button';
import { buttonSx } from '../../styles/Global.style';
import { Feature } from '../../components/Feature/Feature';
import { ACADEMY } from '../../constants/academy';

export const Academy = () => {
  const theme = useTheme();

  return (
    <>
      <Box>
        <ContentCard
          title={Copy.generate('Academy.title')}
          heading={Copy.inject('Academy.heading', {
            all: dynamicTextColor('all levels.', theme.palette.quaternary.main),
          })}
          isColumn
          isTop
        />

        <ContentCard isSecondaryCard isColumn isTop>
          <Box component="div" sx={{ display: 'flex', flexFlow: 'row wrap' }}>
            {ACADEMY.map((f, i) => (
              <Feature
                key={i}
                icon={f.icon}
                heading={f.heading}
                content={f.content}
              />
            ))}
          </Box>
        </ContentCard>

        <ContentCard
          heading={Copy.inject('Academy.subheading', {
            grows: dynamicTextColor(
              'confidence grows,',
              theme.palette.quaternary.main,
            ),
          })}
          isColumn
        />

        <ContentCard
          heading={Copy.inject('Academy.contactUs.heading', {
            open: dynamicTextColor('open now.', theme.palette.quaternary.main),
          })}
          isSecondaryCard
          isColumn
        >
          <Box>
            <Button
              text={Copy.generate('Buttons.register')}
              onClick={() =>
                (window.location.href =
                  'https://form.jotform.com/241020641546345')
              }
              sx={buttonSx(theme)}
            />
          </Box>
        </ContentCard>
      </Box>
    </>
  );
};
